import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { IRootStoreProps, WithoutStore, withStore } from '../../../stores';
import { IRemoveBalanceForm, TransactionTypeEnum } from '../store';
import { TransfersBalance } from '../components/TransfersBalance.component';
import Title from 'antd/es/typography/Title';
import { Button, Divider, Flex, Form, FormInstance, Input, InputNumber, Radio } from 'antd';

class _RemoveBalanceUser extends Component<IRootStoreProps> {
  private _formRef = React.createRef<FormInstance>();
  state = { value: '' };

  componentDidMount(): void {
    this.props.store.user.transactionType = TransactionTypeEnum.WITHDRAWAL;
    this.props.store.user.getTransfers();
  }
  render() {
    const { user, loading } = this.props.store;

    const label = this.state.value === 'CRYPTO-BOT' ? 'Ваш телеграм:' : '№ кошелька';

    return (
      <TransfersBalance
        title={'Вывод средств'}
        tableTitle={'Ваши последние заявки на вывод:'}
        list={user.transferList}
        total={user.totalTransfers}
        limit={user.getTransfersParams.limit}
        handleTableChange={user.handleTableChange}
        changeWitdrawalTransfer={user.changeWitdrawalTransfer}
      >
        <Title level={5}>{'Заявка на вывод:'}</Title>
        <Form
          ref={this._formRef}
          name="validate_other"
          onFinish={this._handleFinish}
          initialValues={{
            amount: 10,
          }}
        >
          <Form.Item<IRemoveBalanceForm>
            name="currency"
            label="В чем"
            rules={[{ required: true, message: 'В чем вывести?' }]}
          >
            <Radio.Group onChange={e => this.setState({ value: e.target.value })}>
              <Radio.Button value="BTC">BTC</Radio.Button>
              <Radio.Button value="USDT">USDT(TRC-20)</Radio.Button>
              <Radio.Button value="ETH">ETH</Radio.Button>
              <Radio.Button value="LTC">LTC</Radio.Button>
              <Radio.Button value="CRYPTO-BOT">CryptoBot</Radio.Button>
            </Radio.Group>
          </Form.Item>
          <Flex>
            <Form.Item<IRemoveBalanceForm>
              name="wallet"
              label={label}
              rules={[{ required: true, message: 'Куда выводим?' }]}
            >
              <Input style={{ width: 350, marginRight: 20 }} />
            </Form.Item>
            <Form.Item<IRemoveBalanceForm> label="Сумма" name="amount" rules={[{ required: true }]}>
              <InputNumber min={0} />
            </Form.Item>
            <Form.Item wrapperCol={{ span: 12, offset: 6 }}>
              <Button type="primary" htmlType="submit" loading={loading}>
                Отправить
              </Button>
            </Form.Item>
          </Flex>
        </Form>
        <Divider />
      </TransfersBalance>
    );
  }

  private _handleFinish = async (values: IRemoveBalanceForm) => {
    const { user } = this.props.store;

    await user.createWitdrawalTransfer(values);
    if (this._formRef.current) {
      this._formRef.current.resetFields();
    }
  };
}

export const RemoveBalanceUserPage: WithoutStore = withStore(observer(_RemoveBalanceUser));
